import Vue from "vue";

export default {
    async getMainRulesRef(lang) {
        await Vue.state.client.ensure();
        return Vue.state.client.get().view.legal.mainRules.find(r => r.language == lang)
            || Vue.state.client.get().view.legal.mainRules.find(r => r.language == 'en')
            || null;
    }
}


// WEBPACK FOOTER //
// ./_common/helpers/rules.helper.js